import { render, staticRenderFns } from "./ClinicShowUser.vue?vue&type=template&id=2fede962"
import script from "./ClinicShowUser.vue?vue&type=script&lang=js"
export * from "./ClinicShowUser.vue?vue&type=script&lang=js"
import style0 from "./ClinicShowUser.vue?vue&type=style&index=0&id=2fede962&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports